export function getDocumentSourceImageUrl (document) {
    if (document.sourceUrl !== null) {
        return `https://shuhari-iconoclast-production.herokuapp.com/favicon?size=48&url=${new URL(document.sourceUrl).origin}`;
    }
}
